import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import WorksProductivityNormsDt from '@/services/dataTransferModules/worksProductivityNormsDt'

const worksProductivityNormsDt = new WorksProductivityNormsDt()

export default function useWorksProductivityNorms() {
	const { t: $t } = useI18n()

	const {
		loadEntityFlags: flags,

		entities: worksProductivityNorms,
		getEntities: getWorksProductivityNorms,

		basedEntities: basedWorksProductivityNorms,
		getBasedEntities: getBasedWorksProductivityNorms,

		extendedEntities: extendedWorksProductivityNorms,
		getExtendedEntities: getExtendedWorksProductivityNorms,

		entity: worksProductivityNorm,
		getEntity: getWorksProductivityNorm,

		createEntity: createWorksProductivityNorm,
		patchEntity: patchWorksProductivityNorm,
		updateEntity: putWorksProductivityNorm,
		deleteEntity: deleteWorksProductivityNorm,
	} = useBlProviders(worksProductivityNormsDt, {
		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Error loading equipment'),

		showErrorNotificationForLoadingOneEntity: true,
		errorNotificationTextForLoadingOneEntity: $t('Error loading equipment'),

		showErrorNotificationForCreatingEntity: true,
		errorNotificationTextForCreatingEntity: $t('Error loading equipment'),

		showErrorNotificationForUpdatingEntity: true,
		errorNotificationTextForUpdatingEntity: $t('Error loading equipment'),

		showErrorNotificationForDeletingEntity: true,
		errorNotificationTextForDeletingEntity: $t('Error loading equipment'),
	})

	const defaults = {
		creatingWorksProductivityNorm: {
			name: '',
			metric: '',
			optimal_value: '',
			min_value: '',
			max_value: '',
			koef: '',
			work: '',
		},
		fieldsToPatch: ['name', 'metric', 'optimal_value', 'min_value', 'max_value', 'koef', 'work'],
	}

	return {
		flags,
		basedWorksProductivityNorms,
		extendedWorksProductivityNorms,
		worksProductivityNorms,
		worksProductivityNorm,
		defaults,

		getBasedWorksProductivityNorms,
		getExtendedWorksProductivityNorms,
		getWorksProductivityNorms,
		getWorksProductivityNorm,
		createWorksProductivityNorm,
		putWorksProductivityNorm,
		patchWorksProductivityNorm,
		deleteWorksProductivityNorm,
	}
}
